import Flickity from 'flickity';
import themeUtils from '../themeUtils';

export default class DynamicBlog {
  constructor(section) {
    this.container = 'data-blog-container';
    this.slide = '.home-blog-post';
    this.el = section.el;
    this.container = this.el.querySelector(`[${this.container}]`);
    this.flickity = null;
    this._flickity = this._flickity.bind(this);
    this._bindEvents();
    this._flickity();
  }


  _bindEvents() {
    window.addEventListener('resize', themeUtils.debounce(this._flickity, 100));
  }

  onSectionUnload() {
    window.removeEventListener('resize', themeUtils.debounce(this._flickity, 100));
    this._destroyFlickity();
  }

  _flickity() {
    if (!this.container) return;

    // If larger than 'small', destroy Flickity and exit
    if (!themeUtils.isSmall()) {
      this._destroyFlickity();
      return;
    }

    // If Flickity is initialised, exit
    if (this.flickity) {
      return;
    }

    this.flickity = new Flickity(this.container, {
      cellAlign: 'left',
      cellSelector: this.slide,
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      setGallerySize: false,
    });

    this._flickityEvents();
  }

  _destroyFlickity() {
    if (this.flickity) {
      this.flickity.destroy();
      this.flickity = null;

      window.removeEventListener('resize', themeUtils.debounce(() => themeUtils.flickityResize(this.flickity), 10));
      this.container.removeEventListener('rimg:load', () => themeUtils.flickityResize(this.flickity));
    }
  }

  _flickityEvents() {
    // Check for tallest slide at start of transition
    this.flickity.on('cellSelect', () => themeUtils.flickityResize(this.flickity));

    // Check for tallest slide at end of transition
    this.flickity.on('settle', () => themeUtils.flickityResize(this.flickity));

    this.container.addEventListener('rimg:load', () => themeUtils.flickityResize(this.flickity));

    // Sets the Slider to the height of the first slide
    themeUtils.flickityResize(this.flickity);

    window.addEventListener('resize', themeUtils.debounce(() => themeUtils.flickityResize(this.flickity), 10));
  }
}
